var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1474_15138)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.234 0H1.764C.79 0 0 .791 0 1.766v28.47C0 31.21.791 32 1.766 32h28.468c.975 0 1.766-.79 1.766-1.766V1.764C32 .79 31.209 0 30.234 0z",
    fill: "#4267B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.094 32V19.625h4.172l.625-4.844h-4.797v-3.085c0-1.399.388-2.352 2.394-2.352h2.543v-4.32c-.442-.06-1.96-.191-3.726-.191-3.688 0-6.211 2.25-6.211 6.384v3.564h-4.157v4.844h4.157V32h5z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1474_15138"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 6,
    fill: "#fff"
  })))));
};
export default SvgFacebook;